import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    "& td, & th": {
      borderBottom: "none",
      textAlign: "center",
      whiteSpace: "nowrap",
    },
  },
  years5: {
    backgroundColor: "rgb(253, 238, 155)",
  },
  years10: {
    backgroundColor: "rgb(234,232,151)",
  },
  years15: {
    backgroundColor: "rgb(189,218,142)",
  },
  years20: {
    backgroundColor: "rgb(99,189,123)",
  },
  optimal: {
    "& td": {
      fontWeight: "bolder",
    },
  },
});
